import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { DiscoveryFlight } from '@/components/sections/DiscoveryFlight';
import { TrainingJourney } from '@/components/sections/TrainingJourney';
import { Experience } from '@/components/sections/Experience';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        <meta name="robots" content="max-image-preview:large" />
        
        {/* Canonical URL */}
        <link rel="canonical" href={siteData.canonicalUrl} />
        
        {/* Open Graph tags */}
        <meta property="og:title" content={siteData.openGraph.title} />
        <meta property="og:description" content={siteData.openGraph.description} />
        <meta property="og:type" content={siteData.openGraph.type} />
        <meta property="og:url" content={siteData.openGraph.url} />
        <meta property="og:image" content={`${siteData.url}${siteData.openGraph.image}`} />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content={siteData.twitter.card} />
        <meta name="twitter:title" content={siteData.twitter.title} />
        <meta name="twitter:description" content={siteData.twitter.description} />
        <meta name="twitter:image" content={`${siteData.url}${siteData.twitter.image}`} />
        
        {/* Favicon */}
        <meta name="msapplication-TileImage" content="/images/logo.png" />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        <main>
          <Hero />
          <DiscoveryFlight />
          <TrainingJourney />
          <Experience />
        </main>
        
        <Footer />
      </div>
    </>
  );
}